import {combineReducers} from 'redux'
import * as actions from './CashFlowChartActions'

const initialState = {
}


const CashFlow = (state = initialState, action) => {
    switch (action.type) {
        case actions.RECEIVE_CASHFLOW_DATA:
            return Object.assign({}, state, {
                [action.clientId]: {
                    resp_data: action.data,
                    clientId: action.data.clientId,
                    is_initialized: true
                }
            })
        case 'OVERVIEW.UNSET':
            return Object.assign({}, state, {
                [action.clientId]: {
                    is_initialized: false
                }
            })
        default:
            return state
    }
}

export default CashFlow